<template>
  <v-container id="drive-log-detail">
    <div class="page-title">{{$route.name}}</div>
    <v-row>
      <v-col class="d-flex justify-end">
        <c-btn color="blue" @click="openForceStopDialog = true" class="mr-1"  outlined iconName="cancel" :disabled="isNeedForceStop">주행 강제 종료</c-btn>
        <c-btn color="blue" @click="addUnknownPassenger" class="mr-1" outlined iconName="mdi-format-list-bulleted-square">미예약자 변경</c-btn>
        <c-btn color="grey" @click="$router.go(-1)" outlined iconName="mdi-format-list-bulleted-square">돌아가기</c-btn>
      </v-col>
    </v-row>
    <c-card v-if="this.details">
      <v-row align="center" class="my-4">
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">예약정보</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <c-btn color="blue" outlined :to="`/reservation/${reservationInfo.reservationId}`"> 예약정보 확인하기</c-btn>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">예약 날짜</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ reservationInfo.receptionDate ? $func.dateTimeToString(reservationInfo.receptionDate) : ''}}</span>
        </v-col>
      </v-row>
      <v-divider/>

      <v-row>
        <v-col cols="6" class="font-weight-black">
          탑승자 목록
        </v-col>
        <v-col cols="6" class="text-right pr-8 subtitle-1 font-weight-bold">
          <span class="blue--text"> 총 {{details.riderCount}} 명 </span>
        </v-col>
        <v-col cols="12">
          <c-table :headers="passengersInfoTableHeaders" :items="passengers" hide-default-footer>
            <template #order="{item}">
              {{passengers.indexOf(item)+1}}
            </template>
            <template #passengerType="{item}">
              {{$func.displayPassengerType(item.passengerType)}}
            </template>
            <template #name="{item}">
              {{item.customer ? item.customer.name : '-'}}
            </template>
            <template #customerNo="{item}">
              {{item.customerNo? item.customerNo : '-'}}
            </template>
            <template #customerType= {item}>
              {{item.customerType ? $func.displayCustomerType(item.customerType) : '비회원'}}
            </template>
            <template #etc="{item}">
              {{$func.displayWeakCustomerInfo(item.mobilityWeakInfo, item.pregnantInfo) }}
            </template>
            <template #usages="{item}">
              {{item.usages ? item.usages : '미확인'}}
            </template>
            <template #luggage="{item}">
              {{item.luggage ? item.luggage : '없음'}}
            </template>
            <template #boarded="{item}">
              <v-menu offset-y>
                <template #activator="{on}">
                  <v-chip dark :class="item.isBoarded? 'light1Green':'light1Red'" v-on="item.passengerType !== 'UNKNOWN' ? on : null">{{item.isBoarded? '탑승':'미탑승'}}</v-chip>
                </template>
                <v-list>
                  <v-list-item @click="onConfirmChangeBoarded(item.passengerId)">
                    <v-list-item-title> {{!item.isBoarded? '탑승':'미탑승'}}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template #detail="{item}">
              <c-btn v-if="item.customerId" icon iconName="search" :to="`/customers/${item.customerId}`"></c-btn>
            </template>
            <template #delete="{item}">
              <c-btn v-if="!item.customerId" icon iconName="mdi-close"  @click="onConfirmDeleteUnknown(passengers.indexOf(item))"></c-btn>
            </template>
          </c-table>
        </v-col>
      </v-row>
      <v-divider></v-divider>

      <v-row align="center" class="my-4">
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">적용 바우처</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span style="cursor: pointer">{{ couponInfo }}</span>
        </v-col>
      </v-row>
      <v-divider></v-divider>

      <v-row align="center" class="my-4">
        <v-col cols="12">
          <span class="font-weight-black">[기사 정보]</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">기사 이름</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
              <span style="cursor: pointer"
                    @click="$router.push(`/drivers/${reservationInfo.driverId}`)"> {{ reservationInfo.driverName }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">차량 정보</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span> {{ reservationInfo.vehicleType }} / {{ reservationInfo.modelName }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">기사 연락처</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ reservationInfo.driverNumber }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">차량번호</span>
        </v-col>
        <v-col cols="12" md="4" sm="4">
          <span>{{ reservationInfo.plateNo }}</span>
        </v-col>
        <v-col cols="12" sm="12" md="6"></v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">차량 옵션</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">{{ getReservationData('vehicleOption') }}</v-col>
      </v-row>

      <v-divider/>

      <v-row align="center" class="my-4">
        <v-col cols="12">
          <span class="font-weight-black">[주행 정보]</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">총 서비스 시간</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span v-if="isForceStopDrive"> {{ displayDuration(details.totalDuration) }}</span>
          <span v-else> {{ displayDuration(details.waitDuration + details.driveDuration + details.serviceDuration) }} </span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">출발 시간</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span>{{ this.details.startTime ? $func.dateTimeToString(this.details.startTime) : ''}}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">도착 시간</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span>{{ this.details.endTime ? $func.dateTimeToString(this.details.endTime):'' }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">대기 시간</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span>{{ displayDuration(this.details.waitDuration) }}<br>{{ this.waitLog.join(", ") }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">도움서비스 시간</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ displayDuration(this.details.serviceDuration) }}<br>{{ this.serviceLog.join(", ") }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">
            <c-btn outlined color="indigo" small @click="updatePassengerDialog = true">탑승인원변경</c-btn>
          </span>
        </v-col>
        <v-col cols="12" sm="6" md="4"></v-col>
        <template v-for="(item, index) in this.details.reservationRouteList">
          <v-col cols="12" md="2" sm="6" class="align-self-center" :key="index">
            <span v-if="item.seq === 0" class="font-weight-black">출발지</span>
            <span v-else-if="item.seq > 1" class="font-weight-black">경유지{{item.seq - 1}}</span>
            <span v-else-if="item.seq === 1" class="font-weight-black">도착지</span>
          </v-col>
          <v-col cols="12" md="4" sm="6" :key="index">
            <div>{{item.position}}</div>
            <div>{{item.comment}}</div>
          </v-col>
          <v-col cols="12" md="6" sm="6" :key="index">
            <div class="d-flex">
              <div :class="`${item.seq === 1 ? '' : 'font-weight-black'}`">탑승</div>
              <div v-if="item.seq !== 1" class="ml-2">{{item.onCnt}}명</div>
              <div v-else class="ml-3">-</div>
            </div>

            <div class="d-flex">
              <div :class="`${item.seq === 0 ? '' : 'font-weight-black'}`">하차</div>
              <div v-if="item.seq !== 0" class="ml-2">{{item.offCnt}}명</div>
              <div v-else class="ml-3">-</div>
            </div>
          </v-col>
        </template>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">탑승 인원</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span>{{ this.details.riderCount }} 명</span>
        </v-col>
      </v-row>

      <v-divider/>

      <v-row align="center" class="my-4">
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">OBD2 측정 거리</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span> {{ displayDistance(this.details.collectedTotalDistance).toFixed(3) }} km</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">기준 주행 거리</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ displayDistance(details.selectedTotalDistance).toFixed(3) }} km</span>
          <span> ({{ this.details.selectedDistanceType ?  this.details.selectedDistanceType : 'OBD2 주행 거리' }})</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">GPS 주행 거리</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ displayDistance(this.details.totalDistance).toFixed(3) }} km </span>
        </v-col>
        <!-- 수정이 필요한 부분이나 시간이 없어 임시로 주석처리 -->
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">자동 계산 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.autoCalFee).toLocaleString() }}</span>
        </v-col>

        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">지도 계산 거리</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span>{{ displayDistance(this.details.apiSupportedDistance).toFixed(3) }} km</span>
        </v-col>

        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">기사 입력 거리</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>
            {{ this.details.driveDistance }}
            <br>
            {{ this.details.betweenDriveDistance }}
          </span>
        </v-col>

      </v-row>

      <v-row align="center" class="my-2">
        <v-col cols="6">
          <div id="naverMap" style="position:relative; width:100%;height:500px;padding:0;margin:0;"></div>
        </v-col>
        <v-col cols="6">
          <div id="locationTable">
            <div class="tableScroll">
              <c-table :headers="headers1" :items="pathLogItems" @click="onClickTableRow"
                       hide-default-footer disable-pagination v-model="selectedMarker2"
                       single-select item-key="idx">
              </c-table>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-divider/>

      <v-row align="center" class="my-4">
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">[결제 정보]</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <c-btn color="blue" outlined @click="onUpdateDriveLogUpdatePayDialog"> 결제정보 변경하기</c-btn>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">총 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.totalFee).toLocaleString() }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">결제 상태</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ this.details.payStatus.configName }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">주행 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.driveFee).toLocaleString() }}</span>
          <c-btn v-if="showPayLog" color="grey" icon iconName="create" iconSize="16"
                 @click="onUpdateDriveLogUpdateFee"/>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">실 결제 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.paidFee).toLocaleString() }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">대기 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.waitFee).toLocaleString() }}</span>
          <c-btn v-if="showPayLog" color="grey" icon iconName="create" iconSize="16"
                 @click="onUpdateDriveLogUpdateFee"/>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">미수금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.unpaidFee).toLocaleString() }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">도움서비스 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.serviceFee).toLocaleString() }}</span>
          <c-btn v-if="showPayLog" color="grey" icon iconName="create" iconSize="16"
                 @click="onUpdateDriveLogUpdateFee"/>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">결제 수단</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ this.details.payMethod ? this.details.payMethod.configName : '' }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">추가 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.extraFee).toLocaleString() }}</span>
          <c-btn v-if="showPayLog" color="grey" icon iconName="create" iconSize="16"
                 @click="onUpdateDriveLogUpdateFee"/>
        </v-col>
        <v-col cols="24" md="6" sm="12"></v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">할인 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.discountFee) > 0 ? '-'+Number(this.details.discountFee).toLocaleString() : '0' }}</span>
          <c-btn v-if="showPayLog" color="grey" icon iconName="create" iconSize="16"
                 @click="onUpdateDriveLogUpdateFee"/>
        </v-col>
        <template v-if="this.showExtraPayInfo">
          <v-col cols="12" md="2" sm="6">
            <span class="font-weight-black">추가 결제 일시</span>

          </v-col>
          <v-col cols="12" md="4" sm="6">
            <span>{{ this.details.extraPayTime ? $func.dateToString(this.details.extraPayTime):'' }}</span>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <span class="font-weight-black">추가 결제 수단</span>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <span>{{ this.details.extraPayMethod.configName }}</span>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <span class="font-weight-black">추가 결제 금액</span>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <span>{{ Number(this.details.extraPaidFee).toLocaleString() }}</span>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <span class="font-weight-black">추가 결제자 이름</span>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <span>{{ this.details.extraPayCustomerName }}</span>
          </v-col>
        </template>


      </v-row>


      <template v-if="this.showPayLog">
        <v-divider/>
        <v-row justify="center" class="my-4">
          <v-col cols="12">
            <span class="font-weight-black">[결제 내역]</span>
          </v-col>
          <v-col cols="12">
            <c-table :headers="headers2" :items="payListItems" hide-default-footer
                     disable-pagination item-key="idx">
              <template #payLogType="{item}">
                {{item.payLogType ? item.payLogType.configName : '-'}}
              </template>
              <template #datetime="{item}">
                {{$func.dateTimeToString(item.logTime)}}
              </template>
              <template #discountFee="{item}">
                {{item.discountFee > 0 ? '-'+item.discountFee : '0'}}
              </template>
              <template #detail="{ item }" >
                <div v-if="showDetailButton(item.payLogType)">
                  <c-btn icon iconName="search" @click="onShowDetailPayLog(item.payLogType, item)"></c-btn>
                </div>
              </template>
            </c-table>
          </v-col>
        </v-row>
      </template>

    </c-card>

    <drive-log-update-fee-dialog
        :open.sync="updateDriveLogUpdateFeeDialog"
        :driveLogFeeFormData="driveLogFeeFormData"
        :driveLogFeeInfo="driveLogFeeInfo"
        @reqUpdateDriveLogFee="reqUpdateDriveLogFee"
    />
    <drive-log-update-pay-dialog
        :open.sync="updateDriveLogUpdatePayDialog"
        :driveLogPayFormData="driveLogPayFormData"
        @reqUpdateDriveLogPay="reqUpdateDriveLogPay"
    />
    <drive-log-card-log-dialog
        :open.sync="openDriveLogCardLogDialog"
        :driveLogCardLogData="driveLogCardLogData"
    />
    <drive-log-admin-dialog
        :open.sync="openDriveLogAdminDialog"
        :driveLogAdminData="driveLogAdminData"
    />

    <v-dialog v-model="unknownPassengerInfoDialog" fullscreen
              hide-overlay
              transition="dialog-bottom-transition">
      <c-card class="white">
        <v-toolbar dark color="primary">
          <c-btn icon dark iconName="close" @click="unknownPassengerInfoDialog = false"/>
          <v-toolbar-title>미예약자 변경</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <unknown-passenger-info :clear.sync="unknownPassengerInfoDialog" :reserved-passengers="reservedPassengers" :unknown-passengers="unknownPassengers"></unknown-passenger-info>
      </c-card>
    </v-dialog>

    <force-stop-dialog
        :open-dialog.sync="openForceStopDialog"
        :expected-drive-fee="expectedFee"
        @reqForceStop="reqForceStop"
    ></force-stop-dialog>

    <v-dialog v-if="updatePassengerDialog" v-model="updatePassengerDialog" max-width="800px">
      <c-card class="white">
        <v-card-title>탑승 인원 변경</v-card-title>
        <passenger-update-form
            :passenger-count="details.riderCount"
            :reservation-route-list="details ? details.reservationRouteList : []"
            :passengerDataList.sync="passengerDataList"
        />
        <v-row justify="center" class="mt-10">
          <c-btn class="mr-1" color="blue" outlined @click="updateReservationPassengerCount">수정</c-btn>
          <c-btn color="gray" outlined @click="updatePassengerDialog = false">취소</c-btn>
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
import DriveLogUpdateFeeDialog from "./DriveLogUpdateFeeDialog";
import DriveLogUpdatePayDialog from "./DriveLogUpdatePayDialog";
import DriveLogCardLogDialog from "./DriveLogCardLogDialog";
import DriveLogAdminDialog from "./DriveLogAdminDialog";
import VehicleDetail from "@/views/Default/Vehicle/VehicleDetail";
import UnknownPassengerInfo from "@/views/Default/DriveLog/UnknownPassengerInfo";
import ForceStopDialog from "@/views/Default/DriveLog/ForceStopDialog";
import PassengerUpdateForm from "../../CallTaxi/Reserve/PassengerUpdateForm";

export default {
  components: {
    VehicleDetail,
    DriveLogUpdatePayDialog, DriveLogUpdateFeeDialog, DriveLogCardLogDialog, DriveLogAdminDialog,
    UnknownPassengerInfo, ForceStopDialog,
    PassengerUpdateForm
  },
  data() {
    return {
      param: this.$route.params.id,
      details: null,
      reservationInfo : null,
      waitLog: [],
      serviceLog: [],
      driveLogFeeFormData: {},
      driveLogPayFormData: {},
      driveLogCardLogData: {},
      driveLogAdminData: {},
      driveLogFeeInfo: {},
      showExtraPayInfo: false,
      showPayLog: false,
      naverMap: null,
      naverMapBound: {north: null, south: null, west: null, east: null},
      marker0: null,
      marker1: null,
      marker2: null,
      selectedMarker2: [],
      lines: [],
      headers1: [
        {text: '위치번호', value: 'idx', align: 'center', sortable: false},
        {text: '시간', value: 'time', align: 'center', sortable: false},
        {text: '위치', value: 'address', align: 'center', sortable: false}
      ],
      headers2: [
        {text: '종류', value: 'payLogType', align: 'center', sortable: false},
        {text: '시간', value: 'datetime', align: 'center', sortable: false},
        {text: '총 요금', value: 'totalFee', align: 'center', sortable: false},
        {text: '주행요금', value: 'driveFee', align: 'center', sortable: false},
        {text: '대기요금', value: 'waitFee', align: 'center', sortable: false},
        {text: '도움요금', value: 'serviceFee', align: 'center', sortable: false},
        {text: '추가요금', value: 'extraFee', align: 'center', sortable: false},
        {text: '할인요금', value: 'discountFee', align: 'center', sortable: false},
        {text: '실결제요금', value: 'paidFee', align: 'center', sortable: false},
        {text: '미수금', value: 'unpaidFee', align: 'center', sortable: false},
        {text: '추가결제요금', value: 'extraPaidFee', align: 'center', sortable: false},
        {text: '상세보기', value: 'detail', align: 'center', sortable: false}
      ],
      passengersInfoTableHeaders: [
        {text: 'No.', value: 'order', align: 'center', sortable: false},
        {text: '구분', value: 'passengerType', align: 'center', sortable: false},
        {text: '이름', value: 'name', align: 'center', sortable: false},
        {text: '전화번호', value: 'customerNo', align: 'center', sortable: false},
        {text: '회원유형', value: 'customerType', align: 'center', sortable: false},
        {text: '비고', value: 'etc', align: 'center', sortable: false},
        {text: '용도', value: 'usages', align: 'center', sortable: false},
        {text: '수하물', value: 'luggage', align: 'center', sortable: false},
        {text: '탑승 여부', value: 'boarded', align: 'center', sortable: false},
        {text: '상세보기', value: 'detail', align: 'center', sortable: false},
        {text:'', value:'delete', align:'center', sortable: false},
      ],
      pathLogItems: [],
      payListItems: [],
      updateDriveLogUpdateFeeDialog: false,
      updateDriveLogUpdatePayDialog: false,
      openDriveLogCardLogDialog: false,
      openDriveLogAdminDialog: false,
      updatePassengerDialog: false,
      passengers: [],
      reservedPassengers: [],
      unknownPassengerInfoDialog: false,
      unknownPassengers: [],
      openForceStopDialog: false,
      expectedFee : 0,
      couponInfo: '',
      passengerDataList: [],
    }
  },
  async mounted() {
    await this.reqDriveLogDetails();
    await this.reqDriveLog2PayLog();
    await this.initMap();
    await this.setMapInfo(); //NOTE reqDriveLogDetails 호출한 뒤에 해야함, 페이지 로딩시 한번만 호출.
  },
  computed: {
    isNeedForceStop() {
       return !(this.details && this.details.driveStatus.configValue === 'ds_drive')
    },
    isForceStopDrive() {
      return this.payListItems.filter(item => item.payLogType.configValue === 'plt_force_done').length > 0;
    }
  },
  watch:{
    unknownPassengerInfoDialog(value) {
      if(!value) {
        this.reqDriveLogDetails();
      }
    }
  },

  methods: {
    async reqForceStop(paymentInfo) {
      const req = {...paymentInfo, driveLogId : this.param};
      try {
        await this.$api.driveForceDone(req);
        await this.$store.commit('snackbar', {color: 'blue', msg: '주행이 강제 종료되었습니다.' })
        await this.$router.go(0);
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqForceStop'});
      }
    },
    getReservationData(key) {
      let data = this.reservationInfo[key];
      if (key === 'created') {
        data = this.$func.dateTimeToString(data);
      } else if (key === 'driveTime') {
        data= this.$func.msToTimeFormat(data);
      } else if (key === 'resrvState') {
        let value = data.configValue;
        if (value === 'rs_complete') {
          this.resrvColor = 'light1Green';
        } else if (value === "rs_driving") {
          this.resrvColor = 'blue';
        } else if (value === 'rs_done') {
          this.resrvColor = 'light2Blue';
        } else if (value === 'rs_cancel') {
          this.resrvColor = 'light2Grey';
        } else if (value === 'rs_receipt') {
          this.resrvColor = 'light1Red';
        } else if (value === 'rs_user_cancel') {
          this.resrvColor = 'red'
        }
        data = data.configName;
      } else if (key === 'driverId') {
        return this.reservationInfo.map((item) => item.driverId);
      } else if (key === 'vehicleId') {
        return this.reservationInfo.map((item) => item.vehicleId);
        // data = data ? data.plateNo + ' | ' + data.modelName : '-';
      } else if (key === 'vehicleType') {
        let vehicleType = [];
        let types = data.split(',');

        for (const i in types) {
          let vehicle = types[i];
          if (vehicle === 'c_11seat') {
            vehicleType.push('11인승');
          }
          if (vehicle === 'c_15seat') {
            vehicleType.push('15인승');
          }
          if (vehicle === 'c_5seat') {
            vehicleType.push('승용차');
          }
          if (vehicle === 'c_9seat') {
            vehicleType.push('9인승');
          }
        }
        data = vehicleType.toString();
      } else if (key === 'vehicleOption') {
        if(!data) return '-';
        let vehicleOption = [];
        if(!data) {
          return '-';
        }
        let options = data.split(',');

        options.forEach((option) => {
          if (option === 'c_wcl'){
            vehicleOption.push("휠체어 리프트");
          } else if(option === 'c_all') {
            vehicleOption.push("모두선택");
          }else {
            vehicleOption.push("없음");
          }
        });
        data = vehicleOption.toString();
      }
      return data;
    },
    initMap() {
      // map 띄우기위한 initialize
      this.naverMap = new naver.maps.Map("naverMap", {
        center: new naver.maps.LatLng(37.523706, 126.925468),
        zoom: 7,
        minZoom: 10
      });

      window.naverMap = this.naverMap;
      naver.maps.Event.once(naverMap, 'init_stylemap', function () {
        try {
          var rightBottomControlHtml = '<div style="width : 10px; height : 30px;"></div>';
          var rightBottomControl = new naver.maps.CustomControl(rightBottomControlHtml, {
            position: naver.maps.Position.RIGHT_BOTTOM
          });
          var zoomControl = new naver.maps.ZoomControl({
            position: naver.maps.Position.RIGHT_BOTTOM,
            style: naver.maps.ZoomControlStyle.LARGE
          });

          rightBottomControl.setMap(naverMap);
          zoomControl.setMap(naverMap);
        } catch (err) {
          console.log(err);
        }
      });
    },
    setMapInfo() {
      if(!this.details) {
        return;
      }
      this.createMarker({ lat : this.details.lat0, lng : this.details.lng0, field:'departure', name:'출발지', toBind: 'marker0'})
      this.createMarker({ lat : this.details.lat1, lng : this.details.lng1, field:'destination', name:'도착지', toBind: 'marker1'});

      if (this.marker2 != null) {
        this.marker2.setMap(null);
        this.marker2 = null;
      }
      this.lines = [];
      this.drawPolyLine();
    },
    createMarker(locationData) {
      let marker = locationData.field === 'departure' ? this.marker0 : this.marker1;

      if (locationData.lat && locationData.lng) {
        this.arrangeNaverMapBound(locationData.lat, locationData.lng);
        if (marker == null) {
          marker = new naver.maps.Marker({
            position: new naver.maps.LatLng(locationData.lat, locationData.lng),
            map: this.naverMap,
            icon: {
              content: [
                `<div class="marker2u ` + locationData.toBind + `">`,
                `<div class="head">` + locationData.name +`</div>`,
                `<div class="line"></div>`,
                `<div class="point"</div>`,
                `</div>`,
              ].join(""),
              size: new naver.maps.Size(83, 61),
              anchor: new naver.maps.Point(41, 57)
            }
          });
        } else {
          marker.setPosition(new naver.maps.LatLng(locationData.lat, locationData.lng));
        }
      } else if (marker != null) {
        marker.setMap(null);
        marker = null;
      }

      if (this.marker2 != null) {
        this.marker2.setMap(null);
        this.marker2 = null;
      }

      if(locationData.field === 'departure') {
        this.marker0 =  marker ? {...marker} : null;
      } else {
        this.marker1 = marker ? {...marker} : null;
      }
    },
    drawPolyLine() {
      this.pathLogItems=[];

      let idx = 1;
      let naverMapPath = [];
      let prevTimestamp = 0;
      let prevItem = {};
      if(!this.details.pathLog || this.details.pathLog.length < 1) return;

      let pathLog = JSON.parse(this.details.pathLog);

      if(this.isForceStopDrive && this.details.totalDuration < 60) {
        this.pathLogItems.push({
          idx: 1,
          time: this.displayTime(this.details.startTime),
          lat: this.details.lat0,
          lng: this.details.lng0,
          address: this.details.addr0
        });
      } else {
        pathLog.forEach((item, i) => {
          let timestamp = this.$moment(item[0]).format("X");
          if (item[3]) {
            this.pathLogItems.push({
              idx: idx++,
              time: this.displayTime(item[0]),
              lat: item[1],
              lng: item[2],
              address: item[3]
            });
          }

          this.arrangeNaverMapBound(item[1], item[2]);

          if ((i > 0 && timestamp - prevTimestamp > 60)) {
            let line = new naver.maps.Polyline({
              map: this.naverMap,
              path: naverMapPath,
              strokeColor: '#046bd8',
              strokeWeight: 3
            });
            this.lines.push(line);

            naverMapPath = [];
            naverMapPath.push(new naver.maps.LatLng(prevItem[1], prevItem[2]));
            naverMapPath.push(new naver.maps.LatLng(item[1], item[2]));

            let shortdashLine = new naver.maps.Polyline({
              map: this.naverMap,
              path: naverMapPath,
              strokeColor: '#046bd8',
              strokeWeight: 3,
              strokeStyle: "shortdash"
            });
            this.lines.push(shortdashLine);

            naverMapPath = [];
          } else if (i == pathLog.length - 1) {
            if (naverMapPath.length > 0) {
              naverMapPath.push(new naver.maps.LatLng(item[1], item[2]));
              var line = new naver.maps.Polyline({
                map: this.naverMap,
                path: naverMapPath,
                strokeColor: '#046bd8',
                strokeWeight: 3,
              });
              this.lines.push(line);
            }
          }

          naverMapPath.push(new naver.maps.LatLng(item[1], item[2]));
          prevTimestamp = timestamp;
          prevItem = item;
        });
      }
      this.fitNaverMapBound();
    },
    async reqDriveLogDetails() {
      try {
        const admin = await this.$api.getLoginedAdmin();
        const res = await this.$api.getDriveLogById(this.param);

        this.details = res.data;
        const routes = this.details.reservationRouteList
        const departuresInfo = routes[0]
        const destinationInfo = routes.find(route => route.seq === 1)

        if(departuresInfo) {
          this.details.addr0 = departuresInfo.position
          this.details.lat0 = departuresInfo.lat
          this.details.lng0 = departuresInfo.lng

          if(destinationInfo) {
            this.details.addr1 = destinationInfo.position
            this.details.lat1 = destinationInfo.lat
            this.details.lng1 = destinationInfo.lng
          }
        }
        this.convertReservationRouteListIndex(routes)

        let driverRecordDistance = this.displayDistance(this.details.driverRecordDistance).toFixed(3)
        let driverRecordDistanceStart = this.displayDistance(this.details.driverStartRecordDistance).toFixed(3)
        let driverRecordDistanceEnd = this.displayDistance(this.details.driverEndRecordDistance).toFixed(3)
        
        this.details.driveDistance = this.details.selectedDistanceType === '기사 입력 거리' ? driverRecordDistance + 'km' : '-'
        
        if(admin.data.centerId.usingDriverRecordDistance) {
            this.details.betweenDriveDistance = `(계기판 거리 : ${driverRecordDistanceStart} km ~ ${driverRecordDistanceEnd} km)` 
            if(driverRecordDistance > 0) {
              this.details.driveDistance = driverRecordDistance + 'km (수정됨)'
            }else {
              const calculate = Number(driverRecordDistanceEnd) - Number(driverRecordDistanceStart) 
              this.details.driveDistance = (calculate < 0 ? 0 : calculate)  + 'km'
            }
        }

        this.reservationInfo = res.data.driveLogReservationRes;
        this.expectedFee = res.data.driveLogReservationRes.fee;
        this.passengers = res.data.passengers;
        this.reservedPassengers = res.data.passengers.filter(item=> item.passengerType !== 'UNKNOWN');
        this.customerName = this.passengers.find(passenger => passenger.passengerType === 'BOOKER').customerName;
        await this.getCouponListData(res.data.driveLogReservationRes.reservationId);

        // 추가결제가 있는경우 표시되는 항목
        if(this.details.extraFee != 0) {
          if(this.details.payStatus.configValue == 'ps_unpaid') {
            this.showExtraPayInfo = false;
          } else if(this.details.paidFee != this.details.totalFee) {
            this.showExtraPayInfo = true;
          }
        } else {
          this.showExtraPayInfo = false;
        }
        // 결제정보 변경하기 > 추가 요금을 입력 했을 때만
        if(this.details.extraPaidFee != 0) {
          this.showExtraPayInfo = true;
        }

        this.waitLog = [];
        this.serviceLog = [];
        if (this.details.statusLog) {
          let statusLog = JSON.parse(this.details.statusLog);
          for (let i = 0; i < statusLog.length; i++) {
            const log = statusLog[i];
            if (log[0] === 'ds_wait') {
              this.waitLog.push(this.displayPeriod(log[1], log[2]));
            } else if (log[0] === 'ds_service') {
              this.serviceLog.push(this.displayPeriod(log[1], log[2]));
            }
          }
        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqDriveLogDetails'});
      }
    },
    async reqDriveLog2PayLog() {
      try {
        if(this.details && this.details.driveStatus.configValue == 'ds_done'){
          this.showPayLog = true;
          const res = await this.$api.getDriveLog2PayLogById(this.param);
          this.payListItems = res.data;
        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqDriveLog2PayLog'});
      }
    },
    async reqUpdateDriveLogFee(data) {
      try {
        await this.$api.updateDriveLogFee(data);
        this.updateDriveLogUpdateFeeDialog = false;
        await this.reqDriveLogDetails();
        await this.reqDriveLog2PayLog();
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqUpdateDriveLogFee'});
      }
    },
    async reqUpdateDriveLogPay(data) {
      try {
        await this.$api.updateDriveLogPay(data);
        this.updateDriveLogUpdatePayDialog = false;
        await this.reqDriveLogDetails();
        await this.reqDriveLog2PayLog();
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqUpdateDriveLogPay'});
      }
    },
    convertReservationRouteListIndex(routeList) {
      if (routeList.length > 0) {
        routeList.sort((a, b) => {
          if (a.seq === 1) {
            return 1
          } else if (b.seq === 1) {
            return -1
          } else {
            return a.seq > b.seq ? 1 : -1
          }
        })
      }
    },
    displayDuration(sec) {
      let hours = Math.floor(sec / 3600);
      let minutes = Math.floor((sec - (hours * 3600)) / 60);
      let seconds = sec % 60;

      return hours + '시간 ' + minutes + '분 ' + seconds + '초';
    },
    displayTime(str) {
      return str ? this.$moment(str).format("HH:mm:ss") : "";
    },
    displayPeriod(str0, str1) {
      return this.$moment(str0).format("HH:mm:ss") + "~" + this.$moment(str1).format("HH:mm:ss");
    },
    displayDistance(distance) {
      return distance > 0 ? Number(distance / 1000) : 0;
    },
    arrangeNaverMapBound(lat, lng) {
      if (this.naverMapBound.north == null) {
        this.naverMapBound.north = lat;
      }
      if (this.naverMapBound.south == null) {
        this.naverMapBound.south = lat;
      }
      if (this.naverMapBound.west == null) {
        this.naverMapBound.west = lng;
      }
      if (this.naverMapBound.east == null) {
        this.naverMapBound.east = lng;
      }

      this.naverMapBound.north = Math.max(this.naverMapBound.north, lat);
      this.naverMapBound.south = Math.min(this.naverMapBound.south, lat);
      this.naverMapBound.east = Math.max(this.naverMapBound.east, lng);
      this.naverMapBound.west = Math.min(this.naverMapBound.west, lng);
    },
    fitNaverMapBound() {
      if (this.naverMapBound.north == this.naverMapBound.south && this.naverMapBound.west == this.naverMapBound.east) {
        this.naverMap.setCenter(new naver.maps.LatLng(this.naverMapBound.south, this.naverMapBound.west));
      } else {
        var latOffset = (this.naverMapBound.north - this.naverMapBound.south) / 10;
        var lngOffset = (this.naverMapBound.east - this.naverMapBound.west) / 10;
        var sw = new naver.maps.LatLng(this.naverMapBound.south - latOffset, this.naverMapBound.west - lngOffset);
        var ne = new naver.maps.LatLng(this.naverMapBound.north + latOffset, this.naverMapBound.east + lngOffset);
        var bounds = new naver.maps.LatLngBounds(sw, ne);
        this.naverMap.fitBounds(bounds);
      }
    },
    onClickTableRow: function (e) {
      this.selectedMarker2 = [e];
      if (this.marker2 != null) {
        this.marker2.setMap(null);
      }
      this.marker2 = new naver.maps.Marker({
        position: new naver.maps.LatLng(e.lat, e.lng),
        map: this.naverMap,
        icon: {
          content: [
            "<div class='marker2u marker2'>",
            "<div class='head'>위치" + e.idx + "</div>",
            "<div class='line'></div>",
            "<div class='point'></div>",
            "</div>"
          ].join(""),
          size: new naver.maps.Size(83, 61),
          anchor: new naver.maps.Point(41, 57)
        }
      });
      window.vueRoot = this;
      naver.maps.Event.addListener(this.marker2, 'click', function () {
        vueRoot.marker2.setMap(null);
        vueRoot.selectedMarker2 = [];
      });
      this.naverMap.setCenter(new naver.maps.LatLng(e.lat, e.lng));
    },
    showDetailButton(payLogType) {
      const value = payLogType.configValue;
      return !(value === 'plt_pay_cash' || value === 'plt_cancel_cash');
    },
    onShowDetailPayLog(payLogType, payLog) {
      const value = payLogType.configValue;
      switch (value) {
        case 'plt_update':
        case 'plt_extra':
        case 'plt_force_done':
          this.getAdminInfoDetail(payLog.id);
          break;
        case 'plt_pay_card' :
        case 'plt_cancel_card' :
          this.getCardLogDetail(payLog.id)
        default :
          break;
      }
    },
    async getCardLogDetail(payLogId) {
      try {
        const res = await this.$api.getCardLogInfo(payLogId);
        this.driveLogCardLogData = res.data;
        this.openDriveLogCardLogDialog = true;
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'getCardLogDetail'});
      }

    },
    async getAdminInfoDetail(payLogId) {
      try {
        const res = await this.$api.getEditAdminInfo(payLogId);
        this.driveLogAdminData = res.data;
        this.openDriveLogAdminDialog = true;
      } catch(err) {
        this.$store.commit('snackbar', {err, where: 'getCardLogDetail'});

      }
    },
    onUpdateDriveLogUpdateFee() {
      this.driveLogFeeFormData = {
        driveLogId: this.details.id,
        waitFee: this.details.waitFee,
        driveFee: this.details.driveFee,
        serviceFee: this.details.serviceFee,
        extraFee: this.details.extraFee,
        discountFee: this.details.discountFee,
      };
      this.driveLogFeeInfo = {
        customerName: this.customerName,
        driverName: this.reservationInfo.driverName,
        plateNo: this.reservationInfo.plateNo,
        totalPaidFee: this.details.paidFee,
        payStatusName: this.details.payStatus.configName,
      }
      this.updateDriveLogUpdateFeeDialog = true;
    },
    onUpdateDriveLogUpdatePayDialog() {
      this.driveLogPayFormData = {
        driveLogId: this.details.id,
        extraPayMethod: this.details.extraPayMethod.configValue,
        extraPayTime: this.details.extraPayTime ? this.$func.dateToString(this.details.extraPayTime) : '',
        payStatus: this.details.payStatus.configValue,
        extraPaidFee: this.details.extraPaidFee,
        extraPayCustomerName: this.details.extraPayCustomerName,
        customerName: this.details.passengers.find(passenger => passenger.passengerType === 'BOOKER').customerName
      };

      this.updateDriveLogUpdatePayDialog = true
    },
    onConfirmDeleteUnknown(index) {
      this.$store.commit('alert',
          {
            open: true, persistent: true, msg: '미예약자를 삭제하시겠습니까?',
            confirm: true, callBack: () => {
              this.reqDeleteUnknownPassenger(index);
            },
          });
    },
    async reqDeleteUnknownPassenger(index) {
      this.passengers.splice(index,1);
      const req = {
        id: this.param,
        riderCount : this.passengers.filter(item => item.isBoarded === true).length
      }
      await this.$api.updateRiderCount(req);
      await this.reqDriveLogDetails();
    },
    onConfirmChangeBoarded(passengerId) {
      this.$store.commit('alert', {
        open: true, persistent: true, msg: '탑승여부를 변경하시겠습니까?', confirm: true,
        callBack:()=> {
          this.reqChangeBoarded(passengerId)
        }
      })
    },
    async reqChangeBoarded(passengerId) {
      const req = {
        passengerId: passengerId,
        driveLogId: this.param
      }
      await this.$api.updatePassengerIsBoarded(req);
      await this.reqDriveLogDetails();
    },
    addUnknownPassenger() {
      this.unknownPassengerInfoDialog = !this.unknownPassengerInfoDialog
      let unknownList =  this.passengers.filter(item=> item.passengerType === 'UNKNOWN');
      let result = []
      //NOTE deep copy해야 현재 화면의 미예약자 수하물 정보가 array로 변하지 않음
      for(let item of JSON.parse(JSON.stringify(unknownList))) {
        item.luggage = item.luggage ? item.luggage.split(',') : item.luggage;
        result.push(item);
      }
      this.unknownPassengers= result;
    },
    onConfirmForceStop() {
      this.openForceStopDialog = true;
    },
    async getCouponListData(id) {
      if(id) {
        const res = await this.$api.getUsedCoupons(id);
        let couponList = '';
        if (res.data.length) {
          for (let i=0;i<res.data.length;i++) {
            couponList += `${res.data[i].couponName} (${res.data[i].passengerName})`
            if (i < res.data.length - 1) couponList += ', '
          }
        }

        this.couponInfo = couponList;
      }
    },
    async updateReservationPassengerCount() {
      const data = this.passengerDataList.map(route => ({
        seq: route.seq,
        onCnt: route.onCnt,
        offCnt: route.offCnt
      }));

      const onCntSum = this.passengerDataList.reduce((acc, value) => (acc + value.onCnt), 0)
      const offCntSum = this.passengerDataList.reduce((acc, value) => (acc + value.offCnt), 0)

      try {
        if (this.details.riderCount === onCntSum
            && this.details.riderCount === offCntSum) {
          await this.$api.updateReservationPassengerCount(this.reservationInfo.reservationId, data)
          this.updatePassengerOnOffCnt()
          this.updatePassengerDialog = false;
        } else if (this.details.riderCount !== onCntSum) {
          this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '탑승 인원의 합을 '+this.details.riderCount+' 명으로 변경해 주세요.'});
        } else if (this.details.riderCount !== offCntSum) {
          this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '하차 인원의 합을 '+this.details.riderCount+' 명으로 변경해 주세요.'});
        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'updateReservationPassengerCount', msg: '문제가 발생하였습니다. 잠시후 다시 시도해주세요.'});
      }
       if(this.details.riderCount !== onCntSum && this.details.riderCount !== offCntSum) {
           this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '탑승, 하차 인원의 합을 '+this.details.riderCount+' 명으로 변경해 주세요.'});
      }
    },
    updatePassengerOnOffCnt() {
      this.details.reservationRouteList = this.details.reservationRouteList.map(item => {
        const passengerData = this.passengerDataList.find(data => data.seq === item.seq)

        return {
          ...item,
          onCnt: passengerData.onCnt,
          offCnt: passengerData.offCnt
        }
      })
    }
  }
}
</script>

<style>
#locationTable {
  position: relative;
  height: 500px;
  padding-top: 48px;
}

#locationTable .tableScroll {
  height: 452px;
  overflow-y: scroll;
}

#locationTable table {
  table-layout: fixed;
  width: 100%;
}

#locationTable thead {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
}

#locationTable thead tr {
  display: inline-table;
  table-layout: fixed;
  width: 100%;
}

#locationTable colgroup col:nth-child(1),
#locationTable tr th:nth-child(1) {
  width: 75px;
}

#locationTable colgroup col:nth-child(2),
#locationTable tr th:nth-child(2) {
  width: 95px;
}

.marker2u {
  position: relative;
  width: 83px;
  height: 61px;
}

.marker2u .head {
  width: 83px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  padding: 12px 0px;
  font-size: 15px;
  color: white;
  border-radius: 20px;
}

.marker2u .line {
  position: absolute;
  left: 41px;
  bottom: 3px;
  width: 1px;
  height: 18px;
}

.marker2u .point {
  position: absolute;
  left: 38px;
  bottom: 0px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.marker2u.marker0 .head,
.marker2u.marker0 .line,
.marker2u.marker0 .point {
  background-color: #318aff;
}

.marker2u.marker1 .head,
.marker2u.marker1 .line,
.marker2u.marker1 .point {
  background-color: #f61955;
}

.marker2u.marker2 .head,
.marker2u.marker2 .line,
.marker2u.marker2 .point {
  background-color: #878787;
}
</style>
